import CareType from '@/types/CareType'
import Care from '@/types/Care'
import moment from 'moment'

export const careTypeOther: CareType = {
  key: 'other',
  label: 'その他',
  image: 'other.png',
  color: '#C9B5AA',
  hasCopy: false,
  hasEndForm: false,
  fields: [
     {
      key: 'memo',
      label: 'メモ',
      type: 'textarea',
      onStartForm: true,
      onEndForm: true,
    },
  ],
}

const careTypes: CareType[] = [
  {
    key: 'milk',
    image: 'milk.png',
    color: '#B8D993',
    label: 'ミルク',
    hasCopy: false,
    hasEndForm: true,
    endFn(care: Care): Care {
      const time = moment().diff(moment(care.caredAt), 'seconds')
      return {...care, careData: {...care.careData, time}}
    },
    fields: [
      {
        key: 'time',
        label: '時間',
        type: 'timer',
        onStartForm: false,
        onEndForm: false,
      },
      {
        key: 'milkAmount',
        label: '作ったミルクの量',
        type: 'number',
        unit: 'ml',
        onStartForm: true,
        onEndForm: false,
      },
      {
        key: 'milkRemainingAmount',
        label: '残ったミルクの量',
        type: 'number',
        unit: 'ml',
        onStartForm: false,
        onEndForm: true,
      },
      {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'nurse',
    image: 'nurse.png',
    color: '#E599A5',
    label: '授乳',
    hasCopy: false,
    hasEndForm: true,
    endFn(care: Care): Care {
      const time = moment().diff(moment(care.caredAt), 'seconds')
      return {...care, careData: {...care.careData, time}}
    },
    fields: [
      {
        key: 'time',
        label: '時間',
        type: 'timer',
        onStartForm: false,
        onEndForm: false,
      },
      {
        key: 'nurseSide',
        label: '胸',
        type: 'radioList',
        default: 'left',
        onStartForm: true,
        onEndForm: true,
        items: [
          {
            key: 'left',
            label: '左'
          },
          {
            key: 'right',
            label: '右'
          },
        ],
      },
      {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'meal',
    image: 'meal.png',
    color: '#EAA473',
    hasCopy: true,
    label: 'ごはん',
    hasEndForm: true,
    endFn(care: Care): Care {
      const time = moment().diff(moment(care.caredAt), 'seconds')
      return {...care, careData: {...care.careData, time}}
    },
    fields: [
      {
        key: 'time',
        label: '時間',
        type: 'timer',
        onStartForm: false,
        onEndForm: false,
      },
      {
        key: 'menu',
        label: '献立',
        type: 'mealMenu',
        onStartForm: true,
        onEndForm: true,
      },
      {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'sleep',
    image: 'sleep.png',
    color: '#70A0C0',
    label: 'おやすみ',
    hasCopy: false,
    hasEndForm: false,
    fields: [
      {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'wakeup',
    image: 'wakeup.png',
    color: '#ECD452',
    label: 'おはよう',
    hasCopy: false,
    hasEndForm: false,
    fields: [
      {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'diaper',
    image: 'diaper.png',
    color: '#B798BB',
    label: 'おむつ',
    hasCopy: false,
    hasEndForm: false,
    fields: [
      {
        key: 'peeAmount',
        label: 'おしっこの量',
        type: 'radioList',
        default: '0',
        onStartForm: true,
        onEndForm: true,
        items: [
          {
            key: '0',
            label: 'なし'
          },
          {
            key: '1',
            label: '少'
          },
          {
            key: '2',
            label: '中'
          },
          {
            key: '3',
            label: '多'
          },
        ],
      },
      {
        key: 'pooAmount',
        label: 'うんちの量',
        type: 'radioList',
        default: '0',
        onStartForm: true,
        onEndForm: true,
        items: [
          {
            key: '0',
            label: 'なし'
          },
          {
            key: '1',
            label: '少'
          },
          {
            key: '2',
            label: '中'
          },
          {
            key: '3',
            label: '多'
          },
        ],
      },
      {
        key: 'leaked',
        label: 'もれた',
        type: 'radioList',
        default: '0',
        onStartForm: true,
        onEndForm: true,
        items: [{
            key: '0',
            label: 'いいえ'
          },
          {
            key: '1',
            label: 'はい'
          },
        ],
      },
      {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'bathing',
    image: 'bathing.png',
    color: '#87C6BC',
    label: 'お風呂',
    hasCopy: false,
    hasEndForm: false,
    fields: [
       {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'antiseptic',
    image: 'other.png',
    color: '#C9B5AA',
    label: '哺乳瓶の消毒液作った',
    hasCopy: false,
    hasEndForm: false,
    fields: [
       {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'goingout',
    image: 'goingout.png',
    color: '#C9B5AA',
    label: 'お出かけ',
    hasCopy: false,
    hasEndForm: false,
    fields: [
       {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'temperature',
    image: 'temperature.png',
    color: '#C9B5AA',
    label: '体温',
    hasCopy: false,
    hasEndForm: false,
    fields: [
      {
        key: 'temperature',
        label: '体温',
        type: 'number',
        unit: '度',
        onStartForm: true,
        onEndForm: true,
      },
      {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'height',
    image: 'height.png',
    color: '#C9B5AA',
    label: '身長',
    hasCopy: false,
    hasEndForm: false,
    fields: [
      {
        key: 'height',
        label: '身長',
        type: 'number',
        unit: 'cm',
        onStartForm: true,
        onEndForm: true,
      },
      {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'weight',
    image: 'weight.png',
    label: '体重',
    color: '#C9B5AA',
    hasCopy: false,
    hasEndForm: false,
    fields: [
      {
        key: 'weight',
        label: '体重',
        type: 'number',
        unit: 'g',
        onStartForm: true,
        onEndForm: true,
      },
      {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'seeADoctor',
    image: 'seeADoctor.png',
    color: '#C9B5AA',
    label: '病院にかかる',
    hasCopy: true,
    hasEndForm: false,
    fields: [
       {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'vaccination',
    image: 'vaccination.png',
    color: '#C9B5AA',
    label: '予防接種',
    hasCopy: true,
    hasEndForm: false,
    fields: [
      {
        key: 'vaccinationType',
        label: '種別',
        type: 'checkList',
        default: [],
        onStartForm: true,
        onEndForm: true,
        items: [
          {
            key: 'hepatitis_b',
            label: 'B型肝炎'
          },
          {
            key: 'rotavirus',
            label: 'ロタウイルス'
          },
          {
            key: 'hib',
            label: 'ヒブ'
          },
          {
            key: 'pneumococcal',
            label: '小児用肺炎球菌'
          },
          {
            key: 'dpt_ipv',
            label: '四種混合（DPT-IPV）'
          },
          {
            key: 'ipv',
            label: '不活化ポリオ（IPV単独）'
          },
          {
            key: 'bcg',
            label: 'BCG'
          },
          {
            key: 'mr',
            label: 'MR（麻しん風しん混合）'
          },
          {
            key: 'varicella',
            label: '水痘（みずぼうそう）'
          },
          {
            key: 'mumps',
            label: 'おたふくかぜ'
          },
          {
            key: 'japanese_encephalitis',
            label: '日本脳炎'
          },
          {
            key: 'influenza',
            label: 'インフルエンザ'
          },
          {
            key: 'hepatitis_a',
            label: 'A型肝炎'
          },
          {
            key: 'meningococcal',
            label: '髄膜炎菌'
          },
          {
            key: 'other',
            label: 'その他'
          },
        ],
      },
      {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  {
    key: 'medicine',
    image: 'medicine.png',
    color: '#C9B5AA',
    label: 'おくすり',
    hasCopy: true,
    hasEndForm: false,
    fields: [
      {
        key: 'medicines',
        label: 'くすり',
        type: 'medicine',
        onStartForm: true,
        onEndForm: true,
      },
      {
        key: 'memo',
        label: 'メモ',
        type: 'textarea',
        onStartForm: true,
        onEndForm: true,
      },
    ],
  },
  careTypeOther,
]


export default careTypes
